import Api from "js/core/api";

function getUserProfile() {
    const promiseCache = {};

    return function getProfileById(userId) {
        if (!userId) {
            return Promise.resolve({ photoUrl: null, email: "" });
        }

        if (promiseCache[userId]) {
            return promiseCache[userId];
        } else {
            let userPromise = Api.getAuthUser.get({ userId });
            promiseCache[userId] = userPromise;
            return userPromise;
        }
    };
}

export default getUserProfile();
